import CustomerServiceManager from './customer-service-manager';
import GroupSwitcher from './group-switcher';

const Views = {
  CustomerServiceManager,
  GroupSwitcher,
};

export default Views;
